import { ofType } from "redux-observable";
import { EMPTY, interval } from "rxjs";
import { switchMap, take } from "rxjs/operators";
import { IdServerPing } from "../../constants/IdServerPing";
import { CommandCode } from "../../utils/network/generated/protoTypes";
import { TypeActionApp } from "../app/actionApp";
export var epicChatServerPing = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionApp.Init), take(1), switchMap(function () {
        // Ping in every 1 hour
        return interval(IdServerPing.ChatServer).pipe(switchMap(function () {
            return deps.chatNetSend({
                id: CommandCode.Ping,
                props: {},
            });
        }), switchMap(function () { return EMPTY; }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/network/epicChatServerPing.ts
// module id = 2005
// module chunks = 3